import { Pagination } from 'antd';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from './dictionary';

export default function CustomPagination(props) {
	const country = props.country || Enviroment.LANGUAGE;
	return <Pagination {...props} className={Dictionary[country][props.className]} />;
}
